module.exports = __webpack_public_path__ + "img/yhubFlow.8a7a1963.gif";